// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import activityApi from '~/apis/activity';
import { GET_ACTIVITY_LIST } from '~/utils/constants/actionType';
import { IQueryParamActivity } from '~/utils/interface/activity';

export const getActivityList = createAsyncThunk(
  GET_ACTIVITY_LIST,
  async (params: IQueryParamActivity, { rejectWithValue }) => {
    try {
      const resp = await activityApi.getActivityList(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
